(function(){
  function closeAll(except){
    document.querySelectorAll('.svp-spec-item').forEach(el=>{
      if(el !== except) el.classList.remove('open');
    });
  }

  document.addEventListener('click', (e)=>{
    const btn = e.target.closest('.svp-spec-header');
    if(!btn) return;
    const item = btn.closest('.svp-spec-item');
    if(!item) return;
    if(!item.classList.contains('open')) closeAll(item);
    item.classList.toggle('open');
  });
})();

document.addEventListener("click", (e) => {
  const dd = e.target.closest(".svhaine-dd");
  document.querySelectorAll(".svhaine-dd").forEach((x) => {
    if (x !== dd) x.classList.remove("is-open");
  });
  if (!dd) return;
  if (e.target.closest(".svhaine-dd__btn")) {
    dd.classList.toggle("is-open");
  }
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document.querySelectorAll(".svhaine-dd").forEach((x) => x.classList.remove("is-open"));
  }
});

/* ─────────────────────────────────────────────────────────────
   [SUPPRIMÉ - P1] Deux IIFE de galerie ciblant #svpMainImage.
   C'était du CODE MORT : le template utilise data-svp-gallery /
   data-svp-main / data-svp-thumb, et aucun #svpMainImage n'existe
   dans le DOM. Les deux blocs sortaient immédiatement (if(!main) return)
   sans jamais agir. La galerie reste pilotée par le script Liquid.
   ───────────────────────────────────────────────────────────── */

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-sv-dd-btn]');
  const anyDD = e.target.closest('[data-sv-dd]');

  // Ferme tout si clic hors dropdown
  if (!anyDD) {
    document.querySelectorAll('[data-sv-dd].is-open').forEach(dd => dd.classList.remove('is-open'));
    return;
  }

  // Toggle sur le dropdown cliqué
  if (btn) {
    const dd = btn.closest('[data-sv-dd]');
    const isOpen = dd.classList.contains('is-open');

    document.querySelectorAll('[data-sv-dd].is-open').forEach(x => x.classList.remove('is-open'));
    if (!isOpen) dd.classList.add('is-open');
  }
});

/* =========================================================
   SVHAINE SIZE GUIDE — SÉLECTEUR CM / IN
   Conserve les mesures propres à chaque produit.
   ========================================================= */
(function () {
  const STORAGE_KEY = 'svhaine-size-unit';
  const TABLE_SELECTOR = '.svp-spec-content table';

  let sizeCopy = {};
  try { sizeCopy = JSON.parse(document.getElementById('SvhaineLocalizationContext').textContent).sizeGuide || {}; } catch (_) {}
  if (!sizeCopy.rows) return;

  const isFrench = () =>
    (document.documentElement.lang || '').toLowerCase().startsWith('fr');

  function rowKind(label) {
    const value = (label || '').toLowerCase();
    if (/largeur|width|breite|anchura|ancho/.test(value)) return 'width';
    if (/manche|sleeve|ärmel|aermel|manga/.test(value)) return 'sleeve';
    if (/tol[eé]rance|tolerance|toleranz|tolerancia/.test(value)) return 'tolerance';
    if (/longueur|length|länge|laenge|largo|longitud/.test(value)) return 'length';
    return '';
  }

  function measurementRows(table) {
    return Array.from(table.rows)
      .map(row => ({ row, kind: rowKind(row.cells[0]?.textContent) }))
      .filter(item => item.kind && item.row.cells.length > 1);
  }

  function isSizeGuide(table) {
    const rows = measurementRows(table);
    if (rows.length < 3) return false;
    const sizes = Array.from(table.rows[0]?.cells || [])
      .map(cell => cell.textContent.trim().toUpperCase());
    return sizes.some(size => /^(?:XXS|XS|S|M|L|XL|[2-9]XL)$/.test(size)) ||
      rows.some(item => item.kind === 'width');
  }

  function parseNumber(value) {
    const match = String(value || '').replace(',', '.').match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : NaN;
  }

  function detectSourceUnit(rows) {
    const labels = rows.map(item => item.row.cells[0]?.textContent || '').join(' ');
    return /(?:^|[,\s])(?:in|inch|inches|pouce|pouces)\b/i.test(labels) ? 'in' : 'cm';
  }

  function defaultUnit() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'cm' || saved === 'in') return saved;
    } catch (error) {}

    const country = String(window.Shopify?.country || '').toUpperCase();
    if (country === 'US' || country === 'GB') return 'in';
    if (country) return 'cm';
    return /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'in' : 'cm';
  }

  function formatValue(value, unit) {
    let formatted = unit === 'cm' ? value.toFixed(1) : value.toFixed(2);
    if (/^(fr|de|es)(?:-|$)/i.test(document.documentElement.lang || '')) formatted = formatted.replace('.', ',');
    return formatted;
  }

  function renderTable(table, unit) {
    const language = sizeCopy;
    measurementRows(table).forEach(({ row, kind }) => {
      row.cells[0].textContent = language.rows[kind] + ', ' + unit;
      Array.from(row.cells).slice(1).forEach(cell => {
        const value = Number(cell.dataset[unit === 'cm' ? 'svCm' : 'svIn']);
        if (Number.isFinite(value)) cell.textContent = formatValue(value, unit);
      });
    });

    table.dataset.svUnit = unit;
    const controls = table.closest('.svp-spec-content')?.querySelectorAll('[data-sv-size-toggle]');
    controls?.forEach(control => {
      control.querySelectorAll('button[data-unit]').forEach(button => {
        const active = button.dataset.unit === unit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  function setUnit(unit) {
    try { localStorage.setItem(STORAGE_KEY, unit); } catch (error) {}
    document.querySelectorAll(TABLE_SELECTOR + '[data-sv-size-guide="true"]')
      .forEach(table => renderTable(table, unit));
  }

  function createToggle(table) {
    const language = sizeCopy;
    const control = document.createElement('div');
    control.className = 'svp-size-unit-toggle';
    control.dataset.svSizeToggle = '';
    control.setAttribute('role', 'group');
    control.setAttribute('aria-label', language.group);

    const label = document.createElement('span');
    label.className = 'svp-size-unit-toggle__label';
    label.textContent = language.label;
    control.appendChild(label);

    ['cm', 'in'].forEach(unit => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'svp-size-unit-toggle__button';
      button.dataset.unit = unit;
      button.textContent = unit.toUpperCase();
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => setUnit(unit));
      control.appendChild(button);
    });

    const wrapper = table.parentElement;
    wrapper.classList.add('svp-size-table-wrap');
    wrapper.parentElement.insertBefore(control, wrapper);
  }

  function addMeasurementNote(table) {
    const language = sizeCopy;
    const wrapper = table.parentElement;
    let note = wrapper.nextElementSibling;
    const looksLikeOldNote = note?.matches('p') &&
      /aisselle|armpit|mesur|measure|taille|size|coupe|fit|größ|groess|talla|medida|ajuste/i.test(note.textContent);

    if (!looksLikeOldNote) {
      note = document.createElement('p');
      wrapper.insertAdjacentElement('afterend', note);
    }

    note.classList.add('svp-size-guide-note');
    note.textContent = language.note;
  }

  function initialiseTable(table) {
    if (table.dataset.svSizeGuide === 'true' || !isSizeGuide(table)) return;

    const rows = measurementRows(table);
    const sourceUnit = detectSourceUnit(rows);

    rows.forEach(({ row }) => {
      Array.from(row.cells).slice(1).forEach(cell => {
        const original = parseNumber(cell.textContent);
        if (!Number.isFinite(original)) return;

        const cm = sourceUnit === 'cm' ? original : original * 2.54;
        const inches = sourceUnit === 'in'
          ? original
          : Math.round((original / 2.54) * 20) / 20;

        cell.dataset.svCm = cm.toFixed(4);
        cell.dataset.svIn = inches.toFixed(4);
      });
    });

    table.dataset.svSizeGuide = 'true';
    table.classList.add('svp-size-guide-table');
    createToggle(table);
    addMeasurementNote(table);
    renderTable(table, defaultUnit());
  }

  function initialiseSizeGuides() {
    document.querySelectorAll(TABLE_SELECTOR).forEach(initialiseTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseSizeGuides);
  } else {
    initialiseSizeGuides();
  }
})();

/* =========================================================
   LANGUAGE HARDENING — FR / EN storefront purity
   ========================================================= */
(function(){
  function localizeProductUi(){
    var ui = {};
    try { ui = JSON.parse(document.getElementById('SvhaineLocalizationContext').textContent).ui || {}; } catch (_) {}
    if (!ui.live) return;
    document.querySelectorAll('.svp-live-label').forEach(function(el){ el.textContent = ui.live; });
    document.querySelectorAll('[data-sv-custom-request-hidden]').forEach(function(input){ input.name = 'properties[' + ui.custom_request + ']'; });
    document.querySelectorAll('[data-sv-source-inspiration-hidden]').forEach(function(input){ input.name = 'properties[' + ui.inspiration + ']'; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', localizeProductUi);
  else localizeProductUi();
})();